import React from 'react'
import ReactPlayer from "react-player";

function Vgallery() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">

                            <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=9D-OLApaLxU" />
                        </div>
                        <div className="col-md-4 mt-3">

                            <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=7gQ9X9e3Umw" />
                        </div>
                        <div className="col-md-4 mt-3">

                            <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=xly9uj4bBMo" />
                        </div>
                    </div>


                </div>
            </div>

        </div>
    )
}

export default Vgallery